/* eslint-disable import/no-extraneous-dependencies */
import React, { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import { FormHelperText, InputAdornment } from '@mui/material';
import classNames from 'classnames';
import styles from './InputText.module.scss'; // Ensure this import is correct and the file exists
import { InputTextProps } from './types';

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  (
    {
      id,
      label,
      name,
      placeholder,
      onChange,
      onBlur,
      value,
      errorMsg,
      isValid = true,
      disabled,
      type = 'text',
      buttonText,
      buttonOnClickHandler = () => null,
      dataTestId = 'input-text-input',
      tabIndex,
    },
    ref?,
  ) => {
    const inputProps = { 
      'data-testid': dataTestId,
      'tabindex': tabIndex,
      ref
    };

    return (
      <div className={classNames({[styles.hide]: type === 'hidden'})}>
        <TextField
          fullWidth
          id={id}
          type={type}
          name={name}
          label={label}
          placeholder={placeholder}
          error={!isValid}
          variant="filled"
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          slotProps={{
            input: {
              inputProps,
              endAdornment: buttonText &&
                <InputAdornment position="end">
                  <button data-testid="input-text-button"
                    className={styles['input-adornment-button']}
                    type="submit" onClick={buttonOnClickHandler}
                  >
                    {buttonText}
                  </button>
                </InputAdornment>
            }
          }}
        />
        {errorMsg ? <FormHelperText
          data-testid="errorMessage"
        >
          {errorMsg ?? ''}
        </FormHelperText> : null}
        
      </div>
    );
  },
);

export default InputText;
